import { getFrontendConfigLoader } from '@doxyme/config';
import { GrowthBook } from '@growthbook/growthbook';

import { getGrowthBookAttributes } from './getGrowthBookAttributes';

const GROWTH_BOOK_API_HOST = 'https://cdn.growthbook.io';

let _growthBookInstance: GrowthBook | undefined;

/**
 * Gets the GrowthBook API host URL, using CDN subdomain if configured.
 * GrowthBook SDK constructs URLs as: {apiHost}/api/features/{clientKey}
 */
const getGrowthBookApiHost = (): string => {
  const config = getFrontendConfigLoader();
  const cdnUrl = config.getOptional('GROWTHBOOK_CDN_URL') as string | undefined;

  // Use CDN subdomain if configured, otherwise fallback to direct GrowthBook CDN
  return cdnUrl || GROWTH_BOOK_API_HOST;
};

// This returns a private growthbook instance, used for internal purposes,
// do not use it growthbook instance directly, use the growthbook config loader instead
export const _getGrowthBookInstance = async (): Promise<GrowthBook> => {
  return (_growthBookInstance ??= new GrowthBook({
    apiHost: getGrowthBookApiHost(),
    clientKey: getFrontendConfigLoader().get(
      'GROWTH_BOOK_CLIENT_KEY',
    ) as string,
    attributes: await getGrowthBookAttributes(),
  }));
};
